import { atom } from "recoil";

export const notificationTagsStore = atom({
	key: "notificationTagsStore",
	default: {
		data: [],
		error: "",
		loaded: false,
		show: false,
		mode: "create",
		editingTag: null,
	},
});
